module.exports = __webpack_public_path__ + "img/ddwu_gallery6.710edcf1.jpg";